'use strict';
const playAudio = document.getElementById('play-audio'),
    audio = document.getElementById('audio'),
    smsSendText = document.getElementById('sms-send-text'),
    sendSmsCode = document.getElementById('send-sms-code'),
    preloader = document.querySelector('.preloader'),
    choosePersonLink = document.querySelectorAll('.choose-person-link'),
    btnChoosePerson = document.getElementById('btn-choose-person'),
    formChangeLink = document.querySelectorAll('.form-change-link'),
    btnSectionChange = document.querySelectorAll('.btn-section-change'),
    btnChangeLocation = document.querySelectorAll('.btn-change-location'),
    btnReload = document.querySelectorAll('.btn-reload'),
    btnResult = document.querySelectorAll('.btn-result'),
    locationInput = document.querySelectorAll('.location input'),
    bodyContainer = document.body;

window.onload=function(){
    bodyContainer.className += "active-section1";
    playAudio.style.display = 'block';

    //vampire01.className += ' slide-in-elliptic-top-fwd';
    preloader.className += ' hide';

    window.scrollTo(0,1);
    /*document.body.requestFullscreen();*/
    //toggleFullScreen()

};
sendSmsCode.addEventListener('click', function () {
    smsSendText.style.display = "block";
    setTimeout(() => smsSendText.style.display = "none", 5000)
});

function toggleFullScreen() {
    var doc = window.document;
    var docEl = doc.documentElement;
    var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
    }
    else {
        cancelFullScreen.call(doc);
    }
}

// if(window.innerHeight < window.innerWidth){
//     alert("Please use Landscape!");
//     bodyContainer.requestFullscreen();
// }

let answerCounter = 1;
for (let input of locationInput) {
    input.addEventListener('click', function () {
        let parentBox = this.parentElement.parentElement.parentElement;
        parentBox.classList.add("input-checked");
        if (this.hasAttribute("data-step")) {
            let bodyAnswerCounter = document.createAttribute('data-right-answer');
            bodyContainer.setAttributeNode(bodyAnswerCounter);
            bodyAnswerCounter.value = answerCounter;
            ++answerCounter;
        }
        if (parentBox.classList.contains("error-box")) {
            parentBox.querySelector('.error-required').style.display = 'none';
        }
        //console.log(parentBox.getElementsByClassName('error-required').length)
    })
}
for (let linkSection of btnSectionChange) {
    linkSection.addEventListener('click', function (e) {
        e.preventDefault();
        let targetId = this.getAttribute("data-target-section");

        this.closest('section').className = "hidden-box";
        document.getElementById(targetId).className = "active-box";
        console.log(targetId);
    });
}
for (let linkReload of btnReload) {
    linkReload.addEventListener('click', function () {
        document.location.reload(true);
    });
}
for (let link of formChangeLink) {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        this.closest('.form-box').classList.remove("active");
        let id = this.attributes.href.nodeValue.slice(1);
        document.getElementById(id).classList.add("active");
    });
}
for (let linkResult of btnResult) {
    linkResult.addEventListener('click', function (e) {
        this.style.display = "none";
        this.nextElementSibling.style.display = "block";
        this.parentNode.nextElementSibling.classList.add("final-person");
    });
}
for (let linkLocation of btnChangeLocation) {
    linkLocation.addEventListener('click', function () {
        let btnHolder = this.parentElement,
            btnLocation = btnHolder.parentElement,
            div = document.createElement('div');
        div.className = "error-required";
        div.innerHTML = "<strong>Выберите один из вариантов ответа</strong>";

        for (let input of btnHolder.querySelectorAll('input')) {
            if (btnLocation.classList.contains("error")) {
                break;
            }
            else if (input.checked) {
                btnLocation.classList.remove("active");
                btnLocation.nextElementSibling.classList.add("active");
            } else {
                btnLocation.classList.add("error-box");
                this.parentElement.insertBefore(div, this.nextSibling);
                console.log('выберите элемент');
            }
        }
    });
}

playAudio.addEventListener('click', function () {
     this.classList.toggle('audio-active');
     !playAudio.classList.contains('audio-active') ? audio.pause() : audio.play();
});


for (let link of choosePersonLink) {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        let elementHolder = this.parentElement.parentElement;
        elementHolder.className += "active-item";
        elementHolder.parentElement.className += "active";
        elementHolder.parentElement.previousElementSibling.style.display = "none";
        btnChoosePerson.style.display = "block";

        let targetId = this.getAttribute("data-person");
        bodyContainer.classList.add(targetId);
    });
}

btnChoosePerson.addEventListener('click', function () {
    bodyContainer.classList.remove('active-section1');
});
lottie.loadAnimation({
    container: document.getElementById('eyes01'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'js/json/eyes.json'
});
lottie.loadAnimation({
    container: document.getElementById('eyes03'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'js/json/eyes.json'
});
setTimeout(function() {
    lottie.loadAnimation({
        container: document.getElementById('eyes02'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'js/json/eyes.json'
    });
}, 3000);

// script for tel mask
window.addEventListener("DOMContentLoaded", function() {
    function setCursorPosition(pos, elem) {
        elem.focus();
        if (elem.setSelectionRange) elem.setSelectionRange(pos, pos);
        else if (elem.createTextRange) {
            var range = elem.createTextRange();
            range.collapse(true);
            range.moveEnd("character", pos);
            range.moveStart("character", pos);
             range.select()
         }
    }

    function mask(event) {
        var matrix = "+7 (___) ___-__-__",
        i = 0,
        def = matrix.replace(/\D/g, ""),
        val = this.value.replace(/\D/g, "");
        if (def.length >= val.length) val = def;
        this.value = matrix.replace(/./g, function(a) {
            return /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? "" : a
        });

        if (event.type == "blur") {
            if (this.value.length == 2) this.value = ""

        } else setCursorPosition(this.value.length, this)
    };

    var input = document.querySelector("#tel");
    input.addEventListener("input", mask, false);
    input.addEventListener("focus", mask, false);
    input.addEventListener("blur", mask, false);
});